import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons-img/folder2.svg'


const _withScopeId = n => (_pushScopeId("data-v-33177140"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-wrapper" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = { class: "folder-item-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "folder-item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "folder"
  })
], -1))
const _hoisted_5 = { class: "folder-input-wrapper" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "folder-input-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "folder-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.folderName) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearValidation && _ctx.clearValidation(...args))),
            type: "text",
            placeholder: _ctx.$localize('create.folder.popup.placeholder')
          }, null, 40, _hoisted_6), [
            [_vModelText, _ctx.folderName]
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", {
          class: "btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, _toDisplayString(_ctx.$localize('create.folder.popup.cancel.button')), 1),
        _createElementVNode("p", {
          class: _normalizeClass(["btn btn-primary", {disabled: _ctx.error || !_ctx.folderName.length}]),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, _toDisplayString(_ctx.$localize('create.folder.popup.save.button')), 3)
      ])
    ])
  ]))
}